import React from 'react';

import { I18n } from '@fiverr-private/i18n-react';
import { Stack, Card, Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { useResizableRef } from '@fiverr-private/legal_documents_package';

import {
    Collapsible,
    CollapsibleHeader,
    CollapsibleContent,
    CollapsibleHeaderChevron,
} from '@fiverr-private/disclosure';
import { Box } from '@fiverr-private/theme';
import { formatDate } from '../../../utils';
import { ComplianceType } from '../../ComplianceModal/types';

export const CollapsibleComplianceTemplate = ({
    children,
    complianceType,
    status,
    date,
}: {
    children: React.ReactNode;
    complianceType: ComplianceType;
    status: string | React.JSX.Element | null;
    date?: string;
}) => {
    const [isExtended, setIsExtended] = React.useState(false);
    const { ref, compact } = useResizableRef();
    return (
        <Card padding={'0'} borderRadius="lg" ref={ref}>
            <Collapsible
                onToggle={(isCollapsed) => {
                    setIsExtended(isCollapsed);
                }}
                overflow="hidden"
            >
                <CollapsibleHeader
                    id="header"
                    paddingY={compact ? '2.5' : '3'}
                    textProps={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
                >
                    <Stack
                        paddingLeft={compact ? '4' : '5'}
                        paddingRight={compact ? '2' : '3'}
                        justifyContent={'spaceBetween'}
                        alignItems="center"
                    >
                        <Typography
                            color="grey_1200"
                            fontWeight="normal"
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            size={
                                compact
                                    ? 'b_sm'
                                    : {
                                          default: 'b_sm',
                                          sm: 'b_md',
                                      }
                            }
                        >
                            <I18n k={`compliance.types.${complianceType}`} />
                        </Typography>
                        <Stack alignItems="center">
                            {!isExtended && (
                                <>
                                    <Container>{status}</Container>
                                    <Box
                                        display={
                                            compact
                                                ? 'none'
                                                : {
                                                      default: 'none',
                                                      sm: 'inline',
                                                  }
                                        }
                                    >
                                        <Typography
                                            fontWeight="normal"
                                            color="grey_1100"
                                            size={
                                                compact
                                                    ? 'b_sm'
                                                    : {
                                                          default: 'b_sm',
                                                          sm: 'b_md',
                                                      }
                                            }
                                            textOverflow="ellipsis"
                                            whiteSpace="nowrap"
                                            overflow="hidden"
                                        >
                                            {formatDate(date)}
                                        </Typography>
                                    </Box>
                                </>
                            )}
                            <CollapsibleHeaderChevron />
                        </Stack>
                    </Stack>
                </CollapsibleHeader>
                <CollapsibleContent>{children}</CollapsibleContent>
            </Collapsible>
        </Card>
    );
};
